import {ReactSVG} from "react-svg";

export const LogoFriIcon = () => {
    return (
        <ReactSVG src={"/fri-media/lgo-fri.svg"}></ReactSVG>
    );
};